import { ProdutoDesenhoConsulta } from 'src/app/shared/interfaces/produto/produto-desenho.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProdutoAPIService {

  private baseUrl = `${environment.APIEndpoint}produtos`;

  constructor(private http: HttpClient) { }

  getAll(pageNumber: number = 1, pageSize: number = 100, descricao: string = "", codigo: string = "", ativo: boolean = null) {    
    var queryAtivo = "";
    
    if(ativo != null){
      queryAtivo = `&ativo=${ativo}`;
    }

    var queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}&descricao=${descricao}&codigo=${codigo}${queryAtivo}`;
    
    return this.http.get(this.baseUrl + queryParams);
  }

  getById(id: number) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  create(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  update(id: number, data: any) {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  delete(id: number, status: boolean) {
    return this.http.delete(`${this.baseUrl}/${id}?status=${status}`);
  }

  /**
   * Histórico de alterações do CADASTRO do produto.
   *
   * Rota distinta de `getHistorico`, que apesar do nome é o extrato de
   * movimentação de ESTOQUE (entrada/saída, saldo).
   */
  getHistoricoAlteracoes(produtoId: number, pageNumber: number = 1, pageSize: number = 20) {
    return this.http.get(`${this.baseUrl}/${produtoId}/historico-alteracoes?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }
  
  importarPlanilha(data: any) {
    return this.http.post(this.baseUrl + "/importar-produtos", data);
  }

  importarPlanilhaComposto(id: number, data: any) {
    return this.http.post(this.baseUrl + "/importar-produto-composto/" + id, data);
  }

  getProdutoComposto(produtoId: number, tipo: string) {
    return this.http.get(`${this.baseUrl}/${produtoId}/composicao/listar?tipo=${tipo}`);
  }

  /**
   * Desenhos ativos de um ou mais produtos, com o caminho do PDF.
   *
   * Vários ids de uma vez porque quem consome é grid — uma chamada por linha
   * seria N+1.
   */
  getDesenhos(produtoIds: number[]) {
    const ids = [...new Set((produtoIds || []).filter(id => id > 0))];
    const query = ids.map(id => `produtoIds=${id}`).join('&');

    return this.http.get(`${this.baseUrl}/desenhos?${query}`);
  }

  /**
   * Gera de novo a identificação do produto pela regra do cadastro, com a descrição do
   * formulário (mesmo não salva), e já grava só a identificação. A API exige o parâmetro
   * PRODUTO.REGERAR_IDENTIFICACAO (403 sem ele).
   */
  regerarIdentificacao(produtoId: number, descricao: string) {
    return this.http.post<{ identificacao: string; identificacaoAnterior?: string | null }>(
      `${this.baseUrl}/${produtoId}/regerar-identificacao`, { descricao });
  }

  /**
   * O número de desenho já existe? Para a modal de desenho: se é de outro produto (não pode
   * usar), as versões que já tem neste produto e a próxima versão. produtoId 0 = produto novo.
   */
  consultarNumeroDesenho(numero: string, produtoId: number) {
    let query = `numero=${encodeURIComponent(numero)}`;
    if (produtoId > 0) query += `&produtoId=${produtoId}`;
    return this.http.get<ProdutoDesenhoConsulta>(`${this.baseUrl}/desenhos/consulta?${query}`);
  }

  createProdutoComposto(produtoId: number, data: any) {
    return this.http.post(`${this.baseUrl}/${produtoId}/composicao`, data);
  }

  updateProdutoComposto(produtoId: number, composicaoId: number, data: any) {
    return this.http.put(`${this.baseUrl}/${produtoId}/composicao/${composicaoId}`, data);
  }

  deleteProdutoComposto(produtoId: number, id: number) {
    return this.http.delete(`${this.baseUrl}/${produtoId}/composicao/${id}`);
  }

  createProdutoCompostoLista(produtoId: number, data: any) {
    return this.http.post(`${this.baseUrl}/${produtoId}/composicao/lista`, data);
  }

  getProdutoSetor(produtoId: number) {    
    return this.http.get(`${this.baseUrl}/${produtoId}/setor/listar`);
  }

  getProdutoTipoMaterial() {    
    return this.http.get(`${this.baseUrl}/produto-tipo-material`);
  }

  createProdutoSetor(produtoId: number, data: any) {
    return this.http.post(`${this.baseUrl}/${produtoId}/setor`, data);
  }

  updateProdutoSetor(produtoId: number, setorId: number, data: any) {
    return this.http.put(`${this.baseUrl}/${produtoId}/setor/${setorId}`, data);
  }

  deleteProdutoSetor(produtoId: number, id: number, reordenar: boolean) {
    return this.http.delete(`${this.baseUrl}/${produtoId}/setor/${id}?reordenar=${reordenar}`);
  }

  getHistorico(produtoId: number, sort: string, pageNumber: number = 1, pageSize: number = 100, filtros?: any) {    
    var queryParams = `/${produtoId}/historico?pageNumber=${pageNumber}&pageSize=${pageSize}&sort=${sort}`;
    
    if (filtros) {
      if (filtros.dataInicio) {
        queryParams += `&dataInicio=${filtros.dataInicio}`;
      }
      if (filtros.dataFim) {
        queryParams += `&dataFim=${filtros.dataFim}`;
      }
      if (filtros.tipo) {
        queryParams += `&tipo=${filtros.tipo}`;
      }
      if (filtros.usuario) {
        queryParams += `&usuario=${filtros.usuario}`;
      }
      if (filtros.origem) {
        queryParams += `&origem=${filtros.origem}`;
      }
    }
    
    return this.http.get(this.baseUrl + queryParams);
  }

  createProdutoCompostoLote(produtoId: number, data: any) {
    return this.http.post(`${this.baseUrl}/${produtoId}/composicao-lote`, data);
  }
}
